import {createReducer} from '@reduxjs/toolkit';

import {byName, byType, setTypesFilter} from '../actions/filter';

export const initialState = {
  name: '',
  types: {},
};

export default createReducer(initialState, {
  [byName]: (state, {payload: query}) => {
    state.name = query || '';
  },
  [byType]: (state, {payload: type}) => {
    state.types = {
      ...state.types,
      ...type,
    };
  },
  [setTypesFilter]: (state, {payload}) => {
    state.types = payload;
  },
});
